var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icons_-_Mockup",
    width: 24,
    height: 24,
    "data-name": "Icons - Mockup",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1,.prefix__cls-3{fill:#fff}.prefix__cls-1{opacity:0}.prefix__cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0H24V24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_Share",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0H16V16H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5813",
    "data-name": "Group 5813",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_397",
    d: "M5 10L0 0",
    className: "prefix__cls-2",
    "data-name": "Line 397",
    transform: "rotate(90 5 5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_398",
    d: "M0 10L5 0",
    className: "prefix__cls-2",
    "data-name": "Line 398",
    transform: "rotate(90 2.5 7.5)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1090",
    cx: 3,
    cy: 3,
    r: 3,
    className: "prefix__cls-3",
    "data-name": "Ellipse 1090",
    transform: "translate(10)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1091",
    cx: 3,
    cy: 3,
    r: 3,
    className: "prefix__cls-3",
    "data-name": "Ellipse 1091",
    transform: "translate(0 5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1092",
    cx: 3,
    cy: 3,
    r: 3,
    className: "prefix__cls-3",
    "data-name": "Ellipse 1092",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsShare);
export default __webpack_public_path__ + "static/media/icons-share.f6086888401f095e94449f4daec16633.svg";
export { ForwardRef as ReactComponent };